import React, { useContext, useEffect, useState } from 'react'
import 'materialize-css'

import { Card, Row, Col } from 'react-materialize'
import { EsitoResume } from './EsitoResume'
import { GlobalContext } from '../context/GlobalState'


export const EsitoOK = ({datiRichiesta, idCart}) => {
    const { 
        svuotaCarrello,
        saveContext,
        carrello
    } = useContext(GlobalContext);

    const [dati, setDati] = useState(null)

    useEffect(() => {
        if (datiRichiesta) {
            setDati(datiRichiesta)
        }
    }, [datiRichiesta])

    useEffect(() => {
        if (carrello.length) {
            svuotaCarrello()
            saveContext()
        }
    }, [carrello])

    useEffect(() => {
        localStorage.removeItem(idCart)
    }, [idCart])


    return (
        <Card>
            <Row>
                <Col s={12}>
                    <h4>Operazione completata</h4>
                    <p>I seguenti pagamenti:</p>
                    <EsitoResume datiRichiesta={dati} />
                    <p>Sono stati eseguiti con successo.</p>
                    <p>Tra qualche minuto potrai scaricare le ricevute dei tuoi pagamenti accedendo al tuo profilo tramite SPID/CIE o tramite l'app IO</p>
                </Col>
            </Row>
        </Card>
    );
}